module.exports = __webpack_public_path__ + "static/media/PM146.5333c297.png";